<template>
    <div class="forget-box">
        <div class="login-box">
            <div class="left-box">
                <h2 class="tit">场租宝</h2>
                <p class="av-txt">发需求，马上定</p>
            </div>
            <div class="right-box">
                <div class="logo">
                    <img src="../../assets/images/logo.png" alt="">
                </div>
                <div class="input-box">
                    <input type="text" v-model="form.mobile" placeholder="输入您的手机号">
                </div>
                <div class="input-box d-flex">
                    <input class="code-box" autocomplete="off" type="text" v-model="form.code" placeholder="输入您验证码">
                    <span class="code-btn mini" @click="getCode">{{count==0?'获取验证码':'重新获取('+count+'s)'}}</span>
                </div>
                <div class="input-box">
                    <input type="password" autocomplete="off" auto-complete="new-password"  v-model="form.password" placeholder="输入您的新密码">
                </div>
                <div class="btn" @click="resetPassword">立即修改</div>
                <div class="tip">
                    <div class="forget" @click="toLogin">去登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCode,resetPassword} from '../../api/index'
    export default {
        name: "forget",
        data(){
            return{
                username:'',

                form:{
                    mobile:'',
                    password:'',
                    code:'',
                },
                int_password:'',
                isClick:true,
                count:''
            }
        },
        methods:{
            toLogin(){
                this.$router.push({path:'/login'});
            },
            getCode(){
                if(!this.isClick){
                    return;
                }
                if(!/^[1][0-9]{10}$/.test(this.form.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                getCode({
                    mobile:this.form.mobile
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('验证码发送成功');
                        this.isClick=false;
                        const TIME_COUNT = 60;
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                } else {
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    this.isClick=true;
                                }
                            }, 1000)
                        }

                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            resetPassword(){
                if(!/^[1][0-9]{10}$/.test(this.form.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                if(!this.form.code){
                    this.$message.error('请输入验证码');
                    return;
                }
                if(!this.form.password){
                    this.$message.error('请输入密码');
                    return;
                }
                if(this.form.password.length<6){
                    this.$message.error('密码长度最少6位');
                    return;
                }
                resetPassword(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功')
                        this.$router.push({path:'/login'});
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
.forget-box{
    width: 100vw;
    height: 100vh;
    background: url(../../assets/images/bg.jpg) no-repeat;
    background-size: 100% 100%;
    .login-box{
        max-width: 600px;
        width: 45%;
        height: 400px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        box-shadow: 0 0 50px rgb(0,0,0,.5);
        .left-box{
            width: 50%;
            height: 100%;
            background: rgba(255,255,255,0.2);
            border-radius: 6px 0 0 6px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .tit{
                font-size: 30px;
                color: #4890f7;
            }
            .av-txt{
                font-size: 20px;
                font-weight: bold;
                color: #4890f7;
            }
        }
        .right-box{
            width: 50%;
            height: 100%;
            background-color: #fff;
            padding: 20px 20px;
            border-radius: 0 6px 6px 0;
            .logo{
                width: 70px;
                height: 70px;
                margin:0px auto 30px auto;
                img{
                    width: 70px;
                    height: 70px;
                }
            }
            .input-box{
                width: 100%;
                height: 30px;
                background-color: #ffffff;
                margin-bottom: 20px;
                border-bottom: 1px solid #eaeaea;
                padding: 0 10px;
                align-items: center;
                input{
                    border: none;
                    background-color: #fff;
                    width: 100%;
                    outline:0px;
                }
                .code-box{
                    width: 50%;
                }
                .code-btn{
                    text-align: right;
                    display: inline-block;
                    width: 50%;
                    cursor: pointer;
                }
            }
            .btn{
                width: 100%;
                height: 35px;
                border-radius: 30px;
                background-color: #4890f7;
                color: #ffffff;
                font-size: 16px;
                text-align: center;
                line-height: 35px;
            }
            .tip{
                margin-top: 10px;
                color: #999999;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
}
</style>
